import * as L from "leaflet";
import "./leaflet-color-control.css";

L.Control.Color = L.Control.extend({
  update: function (value) {
    return value;
  },
  options: {
    default: "multicolor",
  },
  initialize: function (f, options) {
    this.update = f;
    this.options = options;
  },
  onAdd: function (map) {
    var className = "leaflet-color-control";
    this._container = L.DomUtil.create("div", className);

    this._sliderLink = L.DomUtil.create(
      "a",
      className + "-toggle",
      this._container
    );
    var prefixes = ["-o-", "-ms-", "-moz-", "-webkit-"];
    if (this.options.default === "blue") {
      for (var i = 0; i < prefixes.length; i++) {
        this._sliderLink.style.background =
          prefixes[i] + "linear-gradient(left, #f7fbff, #08306b)";
      }
    }
    if (this.options.default === "green") {
      for (var i = 0; i < prefixes.length; i++) {
        this._sliderLink.style.background =
          prefixes[i] + "linear-gradient(left, #f7fcf5, #00441b)";
      }
    }
    if (this.options.default === "multicolor") {
      for (var i = 0; i < prefixes.length; i++) {
        this._sliderLink.style.background =
          prefixes[i] +
          "linear-gradient(left, #2b83ba, #abdda4, #ffffbf, #fdae61, #d7191c)";
      }
    }

    this._sliderContainer = L.DomUtil.create(
      "div",
      "leaflet-slider-container",
      this._container
    );

    this._sliderContainer.style.borderLeft = "1px solid #ccc";
    this._sliderContainer.style.display = "none";

    this._blueGradient = L.DomUtil.create(
      "a",
      className + "-toggle",
      this._sliderContainer
    );
    this._blueGradient.style.width = "75px";
    this._blueGradient.style.marginRight = "12px";
    this._blueGradient.style.marginLeft = "12px";

    var prefixes = ["-o-", "-ms-", "-moz-", "-webkit-"];
    for (var i = 0; i < prefixes.length; i++) {
      this._blueGradient.style.background =
        prefixes[i] + "linear-gradient(left, #f7fbff, #08306b)";
    }

    this._greenGradient = L.DomUtil.create(
      "a",
      className + "-toggle",
      this._sliderContainer
    );
    this._greenGradient.style.width = "75px";
    this._greenGradient.style.marginRight = "12px";
    this._greenGradient.style.marginLeft = "12px";

    var prefixes = ["-o-", "-ms-", "-moz-", "-webkit-"];
    for (var i = 0; i < prefixes.length; i++) {
      this._greenGradient.style.background =
        prefixes[i] + "linear-gradient(left, #f7fcf5, #00441b)";
    }

    this._gradient = L.DomUtil.create(
      "a",
      className + "-toggle",
      this._sliderContainer
    );
    this._gradient.style.width = "75px";
    this._gradient.style.marginRight = "12px";
    this._gradient.style.marginLeft = "12px";

    var prefixes = ["-o-", "-ms-", "-moz-", "-webkit-"];
    for (var i = 0; i < prefixes.length; i++) {
      this._gradient.style.background =
        prefixes[i] +
        "linear-gradient(left, #2b83ba, #abdda4, #ffffbf, #fdae61, #d7191c)";
    }

    L.DomEvent.disableClickPropagation(this._container);
    if (!L.Browser.android) {
      L.DomEvent.on(this._container, "mouseenter", this._expand, this).on(
        this._container,
        "mouseleave",
        this._collapse,
        this
      );
    }

    if (L.Browser.touch) {
      L.DomEvent.on(this._sliderLink, "click", L.DomEvent.stop).on(
        this._sliderLink,
        "click",
        this._expand,
        this
      );
    } else {
      L.DomEvent.on(this._sliderLink, "focus", this._expand, this);
    }

    L.DomEvent.on(this._blueGradient, "click", L.DomEvent.stop).on(
      this._blueGradient,
      "click",
      (e) => {
        this.update("blue");
        var prefixes = ["-o-", "-ms-", "-moz-", "-webkit-"];
        for (var i = 0; i < prefixes.length; i++) {
          this._sliderLink.style.background =
            prefixes[i] + "linear-gradient(left, #f7fbff, #08306b)";
        }
      },
      this
    );
    L.DomEvent.on(this._greenGradient, "click", L.DomEvent.stop).on(
      this._greenGradient,
      "click",
      (e) => {
        this.update("green");
        var prefixes = ["-o-", "-ms-", "-moz-", "-webkit-"];
        for (var i = 0; i < prefixes.length; i++) {
          this._sliderLink.style.background =
            prefixes[i] + "linear-gradient(left, #f7fcf5, #00441b)";
        }
      },
      this
    );
    L.DomEvent.on(this._gradient, "click", L.DomEvent.stop).on(
      this._gradient,
      "click",
      (e) => {
        this.update("rainbow");
        var prefixes = ["-o-", "-ms-", "-moz-", "-webkit-"];
        for (var i = 0; i < prefixes.length; i++) {
          this._sliderLink.style.background =
            prefixes[i] +
            "linear-gradient(left, #2b83ba, #abdda4, #ffffbf, #fdae61, #d7191c)";
        }
      },
      this
    );

    return this._container;
  },
  _expand: function () {
    this._sliderContainer.style.display = "flex";
  },
  _collapse: function () {
    this._sliderContainer.style.display = "none";
  },
});
export default L.control.color = function (f, options) {
  return new L.Control.Color(f, options);
};
